/** Changelog: every lane switch, tier re-point, pin and policy change. */

import type { ChangelogRow } from "./types.js";
import { formatDate } from "./format.js";
import { PRINT_CARD_STYLE, TABLE_HEADER_CLASS, TABLE_HEADER_STYLE } from "./styles.js";

const KIND_LABELS: Record<ChangelogRow["kind"], string> = {
  lane: "lane",
  tier_model: "tier model",
  workspace_pin: "pin",
  workspace_policy: "policy",
};

export function ChangelogCard({ changelog }: { changelog: ChangelogRow[] }) {
  return (
    <section
      aria-label="Changelog"
      className="overflow-x-auto rounded-[var(--radius-card)] border"
      style={PRINT_CARD_STYLE}
    >
      <h3
        className="px-4 py-2.5 text-sm font-semibold"
        style={{ color: "var(--text-primary)", borderBottom: "1px solid var(--border-subtle)" }}
      >
        Changelog
      </h3>
      {changelog.length === 0 ? (
        <div className="px-4 py-4 text-sm" style={{ color: "var(--text-secondary)" }}>
          No changes yet. Every lane switch, tier re-point, pin and policy change lands here.
        </div>
      ) : (
        <table className="w-full min-w-[720px] text-[12px]" style={{ color: "var(--text-primary)" }}>
          <thead>
            <tr>
              {["What", "Change", "Reason", "By", "When"].map((label) => (
                <th key={label} className={TABLE_HEADER_CLASS} style={TABLE_HEADER_STYLE}>
                  {label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {changelog.map((row) => (
              <tr key={row.id} style={{ borderTop: "1px solid var(--border-subtle)" }}>
                <td className="px-3 py-1.5 font-mono">{`${KIND_LABELS[row.kind] ?? row.kind} · ${row.subject}`}</td>
                <td className="px-3 py-1.5 font-mono">{row.change}</td>
                <td className="px-3 py-1.5" style={{ color: "var(--text-secondary)" }}>
                  {row.reason}
                </td>
                <td className="px-3 py-1.5 font-mono" style={{ color: "var(--text-secondary)" }}>
                  {row.actorEmail ?? row.actorUserId ?? "—"}
                </td>
                <td className="px-3 py-1.5 font-mono">{formatDate(row.createdAt)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}
